// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import vuetifyLoader from 'vuetify-vuejs-loader'
import confirmDialog from 'vuetify-vuejs-confirmdialog'
import Vuelidate from 'vuelidate'
import 'vuetify/dist/vuetify.min.css'
import 'babel-polyfill'
import axios from 'axios'
import Unsplash from 'unsplash-js'
import VueCookie from 'vue-cookie'
import underscore from 'underscore'

window.Vue = Vue
Vue.use(Vuetify)
Vue.use(Vuelidate)
Vue.use(vuetifyLoader)
Vue.use(confirmDialog)
Vue.use(VueCookie)
Vue.config.productionTip = false

const unsplash = new Unsplash({
  applicationId: 'aed0a71db6b6611055398ec7eec5425e6aca9a81fdb54e2cdbb2b7bcbf65f2ad',
  secret: 'd1f148615fd62d87b950ec9c3f9099a211518268c45831617ea1c8abf3cbcd7b'
})

Vue.prototype.$unsplash = unsplash

router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.getters['auth/isLoggedIn']
  const currentUser = store.getters['auth/currentUser']
  const currentToken = store.getters['auth/currentToken']
  var userOrganization = store.getters['getUserOrganization']

  if (isLoggedIn && (!Vue.cookie.get('ykx-v2-cookie-jwt-token') || !Vue.cookie.get('ykx-v2-cookie-jwt-user'))) {
    let cookieUser = {
      uuid: currentUser.uuid,
      firstName: currentUser.firstName,
      lastName: currentUser.lastName,
      email: currentUser.email,
      active: currentUser.active,
      projects: []
    }
    for (var i = 0; i < currentUser.projects.length; i++) {
      cookieUser.projects.push({
        uuid: currentUser.projects[i].uuid,
        name: currentUser.projects[i].name,
        description: currentUser.projects[i].description,
        status: currentUser.projects[i].status})
    }
    Vue.cookie.delete('ykx-v2-cookie-jwt-token', {domain: (process.env.NODE_ENV === 'production' ? '.dataslicer.io' : 'localhost')})
    Vue.cookie.delete('ykx-v2-cookie-jwt-user', {domain: (process.env.NODE_ENV === 'production' ? '.dataslicer.io' : 'localhost')})
    Vue.cookie.set('ykx-v2-cookie-jwt-token', currentToken, {expires: '1M', domain: (process.env.NODE_ENV === 'production' ? '.dataslicer.io' : 'localhost')})
    Vue.cookie.set('ykx-v2-cookie-jwt-user', JSON.stringify(cookieUser), {expires: '1M', domain: (process.env.NODE_ENV === 'production' ? '.dataslicer.io' : 'localhost')})
  }

  if (to.path.includes('/activate')) {
    store.commit('auth/resetToken')
    store.commit('auth/resetUser')
    try {
      await store.dispatch('auth/activate', { uuid: to.path.split('/')[to.path.split('/').length - 1] })
      next('/home')
      store.commit('notification/notify', {message: 'User account has been successfully activated. \n You can now login.', show: true})
    } catch (e) {
      console.log(e)
      store.commit('notification/notify', {message: 'Something went wrong. Please try again later.', show: true})
      next('/home')
    }
    next('/login')
  } else if (to.path.includes('/signup')) {
    store.commit('auth/resetToken')
    store.commit('auth/resetUser')
    if (to.path.includes('by-uuid')) {
      store.commit('setNewUserUuid', to.path.split('/')[to.path.split('/').length - 1])
      next({path: '/signup', query: {user: to.path.split('/')[to.path.split('/').length - 1]}})
    }
    next()
  } else if (to.path.includes('/reset')) {
    store.commit('auth/resetToken')
    store.commit('auth/resetUser')
    store.commit('setNewUserUuid', to.path.split('/')[to.path.split('/').length - 1])
    next({ path: '/login', query: {state: 'reset'} })
  } else if (to.path.includes('/billing')) {
    if (isLoggedIn) {
      if (userOrganization && userOrganization.ownerUserId === currentUser.id) {
        next()
      } else {
        next('/market')
      }
    } else {
      next({ path: '/login', query: { path: '/billing' } })
    }
  } else if (to.path.includes('settings')) {
    if (isLoggedIn) {
      if (userOrganization && Object.keys(userOrganization).length > 0) {
        next()
      } else {
        if (currentUser.organizations.length > 1) {
          var orgQuery = JSON.parse(JSON.stringify(to.query))
          orgQuery.state = 'organization'
          orgQuery.path = to.path
          next({ path: '/login', query: orgQuery })
        } else {
          axios.all([store.dispatch('getOrganizationsWithAllById', {id: currentUser.organizations[0].id})]).then(axios.spread((response) => {
            if (response.data.status === 'SUCCESS') {
              store.commit('setUserOrganization', response.data.payload)
              next()
            }
          })).catch((err) => {
            console.log(err)
          })
        }
      }
    } else {
      next({path: '/login', query: {path: to.path}})
    }
  } else {
    if (isLoggedIn && !to.path.includes('/login')) {
      if (userOrganization && Object.keys(userOrganization).length > 0) {
        next()
      } else {
        if (currentUser.organizations.length > 1) {
          var newQuery = JSON.parse(JSON.stringify(to.query))
          newQuery.state = 'organization'
          newQuery.path = to.path
          next({ path: '/login', query: newQuery })
        } else {
          axios.all([store.dispatch('getOrganizationsWithAllById', {id: currentUser.organizations[0].id})]).then(axios.spread((response) => {
            if (response.data.status === 'SUCCESS') {
              store.commit('setUserOrganization', response.data.payload)
              next()
            }
          })).catch((err) => {
            console.log(err)
          })
        }
      }
    } else {
      next()
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  created () {
    this.$vuetify.theme.primary = '#011E41'
    this.$vuetify.theme.secondary = '#FFFFFF'
    this.$vuetify.theme.accent = '#1226AA'
    this.$vuetify.theme.highlight = '#EBEFFF'
    this.$vuetify.theme.error = '#D50000'
  },
  mounted () {
    const isLoggedIn = store.getters['auth/isLoggedIn']
    if (isLoggedIn) {
      const currentUser = store.getters['auth/currentUser']
      axios.all([store.dispatch('getUserByUuid', {uuid: currentUser.uuid})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          if (!underscore.isEqual(currentUser, response.data.payload)) {
            this.$store.commit('auth/resetToken')
            this.$store.commit('auth/resetUser')
            this.$router.push({path: '/login', query: {state: 'login'}})
            this.$store.commit('notification/notify', {message: 'Your user has been changed, please login again.', show: true})
          }
        } else {
          this.$store.commit('auth/resetToken')
          this.$store.commit('auth/resetUser')
          this.$router.push({path: '/login', query: {state: 'login'}})
          this.$store.commit('notification/notify', {message: 'Your user has been changed, please login again.', show: true})
        }
      })).catch((err) => {
        this.$store.commit('auth/resetToken')
        this.$store.commit('auth/resetUser')
        this.$router.push({path: '/login', query: {state: 'login'}})
        this.$store.commit('notification/notify', {message: 'Your user has been changed, please login again.', show: true})
        console.log(err)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js